// extracted by mini-css-extract-plugin
export default {"mobile":"0","tablet":"48em","navigation":"75em","desktop":"77.5em"};